// Mock data for Kailash Kumar's Portfolio

export const profileData = {
  name: "Kailash Kumar",
  title: "Tech Lead - React Native | ReactJs | NextJs",
  tagline: "Building Scalable Mobile & Web Applications",
  email: "kailashkumar210@gmail.com",
  phone: "+91 8503970104",
  altPhone: "+91 7014157814",
  location: "Rajasthan, India",
  photo: "https://customer-assets.emergentagent.com/job_9fc0f667-8c66-47f3-8bcb-3c6378f0102d/artifacts/nyz6zu10_IMG_6430.JPG",
  cvUrl: "/MyCV.pdf",
  bio: "I am a Software Engineer with 7.5+ years of experience specializing in Mobile Application Development using React Native. I'm proficient in React Native, React Js, Next Js, Node Js and Go Lang. My key objective is to utilize my skills in favor of a reputed company and my personal growth, establishing a lucrative professional career in Computer Science Engineering.",
  socialLinks: {
    linkedin: "https://www.linkedin.com/in/kailashkumar210/",
    github: "https://github.com/kailashkumar210",
    twitter: "https://x.com/kailashkumar210"
  }
};

export const skillsData = {
  primary: [
    { name: "React Native", level: 95 },
    { name: "React Js", level: 90 },
    { name: "Next Js", level: 85 },
    { name: "Node Js", level: 80 },
    { name: "TypeScript", level: 85 },
    { name: "JavaScript", level: 95 }
  ],
  secondary: [
    "Redux", "Redux-Saga", "Redux-Thunk", "Context APIs",
    "Firebase", "AWS Cognito", "AWS Amplify",
    "Pusher Js", "Google APIs", "REST APIs",
    "Git", "GitHub", "Bitbucket", "GitLab"
  ],
  tools: [
    "Macintosh", "Ubuntu", "Windows",
    "InstaBug", "CodePipeline", "CodeBuild"
  ]
};

export const experienceData = [
  {
    id: 1,
    company: "Kissht | Pay With Ring",
    role: "Tech Lead / Senior Developer",
    duration: "Sept 2022 - Present",
    location: "India",
    description: "Leading mobile app development for fintech applications with 10M+ users. Responsible for code reviews, building optimization strategies, guiding junior developers, and implementing complex functionalities.",
    projects: ["Pay With Ring App", "Ring Web App", "Kissht App"],
    techStack: ["React Native", "Redux-Saga", "React Js", "Redux Toolkit"]
  },
  {
    id: 2,
    company: "MyPay / OmniPay / Datman",
    role: "Senior Developer",
    duration: "Sept 2020 - Aug 2022",
    location: "UK (Remote)",
    description: "Developed payment gateway solutions for restaurant customers in the UK. Built full-stack applications including mobile apps, customer portals, and payment gateway frontend.",
    projects: ["OmniPay Mobile App", "OmniPay Customer Portal", "OmniPay Gateway", "Datman App"],
    techStack: ["React Native", "React Js", "Node Js", "AWS Amplify", "AWS Cognito"]
  },
  {
    id: 3,
    company: "Dark Bears Solutions",
    role: "Lead Developer",
    duration: "Feb 2019 - Sept 2020",
    location: "India",
    description: "Led development of multiple mobile applications including ride-sharing platforms similar to Uber. Built 6 projects individually and guided team members.",
    projects: ["Cablinks", "Roadlinks", "Animendations", "RideShare", "AV App", "Health Kangaroo"],
    techStack: ["React Native", "Firebase", "Pusher Js", "Google Maps API"]
  },
  {
    id: 4,
    company: "Q Work Solutions",
    role: "Junior Developer",
    duration: "June 2018 - Dec 2018",
    location: "India",
    description: "Started professional career working on school management system. Integrated key features including Courses, Assignment, and Leave Application modules.",
    projects: ["Studybase"],
    techStack: ["React Native", "Firebase", "Redux", "Redux-Thunk"]
  }
];

export const projectsData = [
  {
    id: 1,
    name: "Pay With Ring",
    category: "Fintech",
    description: "Leading fintech mobile application with 10M+ users. Provides seamless payment and financial services.",
    role: "Senior Developer",
    techStack: ["React Native", "Redux-Saga", "Functional Programming"],
    users: "10M+",
    links: {
      android: "https://play.google.com/store/apps/details?id=com.ideopay.user"
    },
    featured: true
  },
  {
    id: 2,
    name: "Kissht App",
    category: "Fintech",
    description: "Financial services application with 10M+ users for quick loans and credit services.",
    role: "Senior Developer",
    techStack: ["React Native", "Redux-Saga", "Functional Programming"],
    users: "10M+",
    links: {
      android: "https://play.google.com/store/apps/details?id=com.fastbanking"
    },
    featured: true
  },
  {
    id: 3,
    name: "RING Web App",
    category: "Fintech",
    description: "Web application for Ring services built from scratch. Led complete architecture setup and development.",
    role: "Senior Developer",
    techStack: ["React Js", "Redux Toolkit", "Functional Programming"],
    users: "2M+",
    links: {},
    featured: true
  },
  {
    id: 4,
    name: "OmniPay Mobile App",
    category: "Payment Gateway",
    description: "Payment acceptance app for UK restaurant customers with in-house payment gateway integration.",
    role: "Senior Developer",
    techStack: ["React Native", "AWS Cognito", "Redux-Saga", "InstaBug"],
    links: {
      android: "https://play.google.com/store/apps/details?id=com.omnipay.merchant",
      ios: "https://apps.apple.com/mn/app/omnipay/id1581605596"
    },
    featured: true
  },
  {
    id: 5,
    name: "OmniPay Gateway",
    category: "Full Stack",
    description: "Complete payment gateway solution with frontend and backend. Built UI pages and APIs.",
    role: "Full Stack Developer",
    techStack: ["React Js", "Node Js", "AWS Amplify", "CodePipeline"],
    links: {
      web: "https://omni-pay.com/"
    },
    featured: false
  },
  {
    id: 6,
    name: "Cablinks",
    category: "Ride Sharing",
    description: "Uber-like cab booking platform with Rider and Driver apps. Features include ride booking, wallet, online payment, location tracking.",
    role: "Lead Developer",
    techStack: ["React Native", "Firebase", "Pusher Js", "Google Maps API"],
    links: {
      android: "https://play.google.com/store/apps/details?id=com.cablinksrider",
      ios: "https://apps.apple.com/us/app/cablinks/id1480015427"
    },
    featured: true
  },
  {
    id: 7,
    name: "Roadlinks",
    category: "Ride Sharing",
    description: "Another ride-sharing solution with complete driver and rider ecosystems.",
    role: "Lead Developer (Individual)",
    techStack: ["React Native", "Firebase", "Pusher Js", "Google APIs"],
    links: {
      android: "https://play.google.com/store/apps/details?id=com.roadlinks"
    },
    featured: false
  },
  {
    id: 8,
    name: "Studybase",
    category: "EdTech",
    description: "School management system active in India and Netherlands. Integrated Courses, Assignment, and Leave Application features.",
    role: "Junior Developer",
    techStack: ["React Native", "Firebase", "Redux", "Redux-Thunk"],
    links: {
      android: "https://play.google.com/store/apps/details?id=in.studybase.app",
      ios: "https://apps.apple.com/in/app/studybase/id1275006322"
    },
    featured: false
  }
];

export const educationData = [
  {
    id: 1,
    degree: "B.Tech (Computer Science Engineering)",
    institution: "Laxmi Devi Institute of Engineering & Technology, Alwar",
    board: "RTU",
    year: "2018",
    result: "80.00%"
  },
  {
    id: 2,
    degree: "12th Standard",
    institution: "Jawahar Navodaya Vidhyalaya, Jojawar",
    board: "CBSE",
    year: "2014",
    result: "88.00%"
  },
  {
    id: 3,
    degree: "10th Standard",
    institution: "Navjyoti Secondary School, Bijowa",
    board: "RBSE",
    year: "2012",
    result: "83.17%"
  }
];

export const achievementsData = [
  {
    id: 1,
    title: "Employee of the Month",
    description: "Recognized for outstanding performance at Dark Bears Solutions",
    date: "April 2019",
    icon: "trophy"
  },
  {
    id: 2,
    title: "Silver Medal - Block Level",
    description: "Academic excellence in 10th class",
    date: "2012",
    icon: "medal"
  },
  {
    id: 3,
    title: "Chief Coordinator - SANGRAM 2K18",
    description: "Led the annual technical festival",
    date: "2018",
    icon: "users"
  },
  {
    id: 4,
    title: "Vice President - Algo.LIET",
    description: "Technical club leadership role",
    date: "2017-18",
    icon: "code"
  },
  {
    id: 5,
    title: "1st Prize - Blind Coding",
    description: "Won at Sangram 2K16 competition",
    date: "2016",
    icon: "award"
  }
];

export const statsData = [
  { label: "Years Experience", value: "7.5+" },
  { label: "Projects Completed", value: "14+" },
  { label: "Users Impacted", value: "20M+" },
  { label: "Companies Worked", value: "4" }
];
